import { useContext, useEffect, useState } from "react";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import { ClienteContext } from "../contexts/ClienteContext";
import MaskService from "../../../../utils/mask/maskService";
import { validNotNull } from "../../../../utils/validations";
import Swal from "sweetalert2";
import { notify } from "../../../../utils/notify";

const countryInitialState = {
  codigo: "1058",
  descricao: "BRASIL",
  siscomex: "105",
};

const ModalRuralEstablishment = ({ open, setOpen, rowEdit, setRowEdit }) => {
  const {
    ruralEstablishment,
    setRuralEstablishment,
    loadingInputs,
    listUf,
    listCounty,
    listNation,
  } = useContext(ClienteContext);

  const { handleChangeCep, handleChangeUf } = useClienteController();

  const [description, setDescription] = useState("");
  const [stateRegistration, setStateRegistration] = useState("");
  const [cep, setCep] = useState("");
  const [address, setAddress] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [district, setDistrict] = useState("");
  const [uf, setUf] = useState(null);
  const [country, setCountry] = useState(countryInitialState);
  const [contactName, setContactName] = useState("");
  const [telephone, setTelephone] = useState("");
  const [active, setActive] = useState(true);
  const [county, setCounty] = useState(null);
  const [main, setMain] = useState(false);

  const [errorsModal, setErrorsModal] = useState({});

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) return;

    const { data } = rowEdit;

    // Set Informações Estabelecimento
    setActive(!!data.ativo);
    setMain(!!data.principal);
    setDescription(data.descricao || "");
    setStateRegistration(data.inscricao_estadual || "");

    // Set Informações Endereço
    const endereco = data.endereco || null;

    setCep(MaskService.toMask("cep", endereco?.cep || ""));
    setAddress(endereco?.logradouro || "");
    setAddressNumber(endereco?.numero || "");
    setComplement(endereco?.complemento || "");
    setDistrict(endereco?.bairro || "");
    setCounty(
      endereco?.municipio_id
        ? listCounty.find(
            (opt) => opt.codigo === endereco?.municipio_id?.toString()
          )
        : null
    );
    setUf(
      endereco?.estado_id
        ? listUf.find(
            (opt) => opt.id.toString() === endereco?.estado_id?.toString()
          )
        : null
    );
    setCountry(
      endereco?.pais_id
        ? listNation.find((opt) => opt.codigo === endereco?.pais_id?.toString())
        : null
    );

    // Set Informações Contatos
    const contatos =
      Array.isArray(data.contatos) && data.contatos[0]
        ? data.contatos[0]
        : null;

    setContactName(contatos?.infoContato?.nome || "");
    setTelephone(
      MaskService.toMask("cel-phone", contatos?.infoContato?.telefone || "")
    );
  }, [listCounty, listNation, listUf, rowEdit]);

  const handleCloseModal = () => {
    setErrorsModal({});
    setOpen(false);
    setRowEdit(null);
  };

  const handleAdd = (disabledOldMainIndex = null) => {
    try {
      const resultValidation = validNotNull([
        { key: "address", value: address },
        { key: "stateRegistration", value: stateRegistration },
        { key: "uf", value: uf },
        { key: "county", value: county },
        { key: "district", value: district },
        { key: "country", value: country },
        { key: "contactName", value: contactName },
        { key: "telephone", value: telephone },
        { key: "cep", value: cep },
      ]);

      if (!description) {
        resultValidation.error = true;
        resultValidation.errorsValidation.description = "Campo obrigatório";
      }

      if (cep && !MaskService.isValid("cep", cep)) {
        resultValidation.error = true;
        resultValidation.errorsValidation.cep = "CEP inválido";
      }

      if (telephone && !MaskService.isValid("cel-phone", telephone)) {
        resultValidation.error = true;
        resultValidation.errorsValidation.telephone = "Telefone inválido";
      }

      const duplicatedIe = ruralEstablishment?.find(
        (establishment) =>
          establishment?.inscricao_estadual?.replace(/[^0-9]+/g, "") ===
            stateRegistration.replace(/[^0-9]+/g, "") &&
          establishment.index !== rowEdit?.data?.index
      );

      if (duplicatedIe) {
        resultValidation.error = true;
        resultValidation.errorsValidation.stateRegistration =
          "Inscrição Estadual Já Cadastrada";
      }

      setErrorsModal(resultValidation.errorsValidation);

      if (resultValidation.error) return;

      const ruralContact =
        Array.isArray(rowEdit?.data?.contatos) && rowEdit?.data?.contatos[0]
          ? rowEdit?.data?.contatos[0]
          : null;

      const body = {
        id: rowEdit?.data?.id || null,
        ativo: active ? 1 : 0,
        principal: main ? 1 : 0,
        descricao: description,
        inscricao_estadual: stateRegistration,
        cliente_id: rowEdit?.data?.cliente_id || null,
        endereco_id: rowEdit?.data?.endereco_id || null,
        endereco: {
          id: rowEdit?.data?.endereco?.id || null,
          cep: cep.replace(/[^0-9]+/g, ""),
          logradouro: address,
          numero: addressNumber,
          complemento: complement,
          bairro: district,
          municipio_id: county ? county.codigo : null,
          estado_id: uf ? uf.id : null,
          pais_id: country ? country.codigo : null,
        },
        contatos: [
          {
            principal: 1,
            infoContato: {
              id: ruralContact?.infoContato?.id || null,
              nome: contactName,
              telefone: telephone.replace(/[^0-9]+/g, ""),
            },
          },
        ],
      };

      const copy = [...ruralEstablishment];

      if (disabledOldMainIndex || disabledOldMainIndex === 0) {
        copy[disabledOldMainIndex].principal = 0;
      }

      if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
        copy[rowEdit.index] = body;
        setRuralEstablishment(copy);
      } else {
        setRuralEstablishment(() => [...copy, body]);
      }

      handleCloseModal();
    } catch (error) {
      console.error("Add Rural Establishment error: ", error);
    }
  };

  const handleCheckMain = async () => {
    try {
      const mainEstablishment = ruralEstablishment?.find(
        (establishment) =>
          establishment?.principal &&
          establishment.index !== rowEdit?.data?.index
      );
      if (!main) {
        if (mainEstablishment) return handleAdd();

        return Swal.fire({
          icon: "info",
          text: "Um estabelecimento rural deve ser adicionado como principal!",
          confirmButtonText: "OK",
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false,
        });
      }

      if (!mainEstablishment) return handleAdd();

      await Swal.fire({
        icon: "question",
        text: "Há um estabelecimento rural adicionado como principal, deseja tornar esse como principal?",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim",
        showConfirmButton: true,
        showCancelButton: true,
      }).then(async (result) => {
        if (!result.isConfirmed)
          return notify("Operação cancelada!", true, "warning");

        handleAdd(mainEstablishment.index);
      });
    } catch (error) {
      console.error("Check Main Establishment error: ", error);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Cadastro de Estabelecimento Rural
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.description || false}
                helperText={errorsModal.description || ""}
                label="Descrição*"
                maxLength={80}
                value={description}
                setValue={setDescription}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.stateRegistration || false}
                helperText={errorsModal.stateRegistration || ""}
                label="Inscrição Estadual*"
                value={stateRegistration}
                onChange={({ target: { value } }) =>
                  setStateRegistration(
                    (value || "").replace(/[^0-9./-]+/g, "").substring(0, 20)
                  )
                }
              />
            </Grid>

            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.cep || false}
                helperText={errorsModal.cep || ""}
                label="CEP*"
                maxLength={12}
                value={MaskService.toMask("cep", cep)}
                onChange={(e) =>
                  handleChangeCep(e, null, {
                    setCep,
                    setAddress: (value) =>
                      setAddress((value || "").substring(0, 50)),
                    setComplement: () => {},
                    setCounty,
                    setUf,
                    setDistrict: (value) =>
                      setDistrict((value || "").substring(0, 50)),
                  })
                }
                mask="cep"
                endAdornment={<SearchIcon onClick={() => {}} />}
              />
            </Grid>

            <Grid item lg={6} md={7} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.address || false}
                helperText={errorsModal.address || ""}
                label="Endereço*"
                maxLength={120}
                value={address}
                setValue={setAddress}
              />
            </Grid>

            <Grid item lg={1} md={2} sm={6} xs={12}>
              <TextFieldErp
                label="Número"
                value={addressNumber}
                onChange={({ target: { value } }) =>
                  setAddressNumber(
                    (value || "").replace(/[^0-9]+/g, "").substring(0, 10)
                  )
                }
              />
            </Grid>

            <Grid item lg={1} md={2} sm={6} xs={12}>
              <SelectErp
                error={errorsModal.uf || false}
                helperText={errorsModal.uf || ""}
                loading={loadingInputs.listUf || false}
                label="Estado*"
                value={uf}
                setValue={setUf}
                onChange={(e) => handleChangeUf(e, setUf, setCounty)}
                optionsList={listUf}
                descriptionField="estado"
              />
            </Grid>

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <SelectErp
                error={errorsModal.county || false}
                helperText={errorsModal.county || ""}
                loading={loadingInputs.listCounty || false}
                label="Municipio*"
                value={county}
                setValue={setCounty}
                optionsList={
                  uf
                    ? listCounty.filter(
                        (opt) => opt.estado_codigo === uf.codibge
                      )
                    : []
                }
                descriptionField="municipio"
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Complemento"
                maxLength={50}
                value={complement}
                setValue={setComplement}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.district || false}
                helperText={errorsModal.district || ""}
                label="Bairro*"
                maxLength={50}
                value={district}
                setValue={setDistrict}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <SelectErp
                error={errorsModal.country || false}
                helperText={errorsModal.country || ""}
                label="País*"
                value={country}
                setValue={setCountry}
                optionsList={listNation}
                descriptionField="descricao"
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.contactName ? true : false}
                helperText={errorsModal.contactName || ""}
                label="Nome do Contato*"
                maxLength={100}
                value={contactName}
                setValue={setContactName}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.telephone ? true : false}
                helperText={errorsModal.telephone || ""}
                label="Telefone do Contato*"
                maxLength={50}
                value={telephone}
                setValue={setTelephone}
                mask="cel-phone"
              />
            </Grid>

            <Grid item container lg={4} md={6} sm={6} xs={12}>
              <Grid item xs={6}>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={active}
                      onChange={({ target: { checked } }) => {
                        if (!checked) setMain(false);

                        setActive((current) => !current);
                      }}
                      color="primary"
                    />
                  }
                  label="Ativo"
                  labelPlacement="end"
                />
              </Grid>

              <Grid item xs={6}>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={main}
                      onChange={() => setMain((current) => !current)}
                      color="primary"
                      disabled={!active}
                    />
                  }
                  label="Principal"
                  labelPlacement="end"
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleCheckMain} />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalRuralEstablishment;
